import { connect } from "react-redux";

import WrappedGroupedMultiSelect from "../shared_components/wrapped_grouped_multi_select";

export default (action, title, valuesSelector, optionsSelector, wdSelectProps, extraHtmlClasses, textAction, initialTextValueSelector, stateBasedDisable) => {
  const clearable = !!wdSelectProps.clearable;

  const mapStateToProps = (state) => {
    const selectedValues = valuesSelector(state);
    const values = optionsSelector(state);
    const initialTextValue = initialTextValueSelector ? initialTextValueSelector(state) : "";
    let disabled;
    if (stateBasedDisable) {
      disabled = stateBasedDisable(state);
    }

    return { ...wdSelectProps, disabled, values, selectedValues, title, extraHtmlClasses, initialTextValue };
  };

  const mapDispatchToProps = dispatch => ({
    onChange: (e) => {
      if (e && e[0]) {
        dispatch(action(e));
      } else {
        // Only dispatch if the select has actually selected a value. Ignore blanks. UNLESS clearable is true.
        if (clearable) {
          dispatch(action([]));
        }
      }
    },

    onInputChange: e => {
      if (textAction) {
        dispatch(textAction(e));
      }
    }
  });

  return connect(mapStateToProps, mapDispatchToProps)(WrappedGroupedMultiSelect);
};
